@if (this.hasToolbarOptions()) {
    <div
        class="flex flex-col-reverse space-y-1 sm:space-y-0 space-y-reverse sm:flex-row-reverse w-full my-1 items-center sm:space-x-2 sm:space-x-reverse"
    >
        @if (this.options.quickFilter) {
            <app-quick-filter
                class="w-full sm:w-auto"
                [gridApi]="gridApi"
            ></app-quick-filter>
        }
        @if (this.shouldShowClearFilters()) {
            <app-clear-filters
                class="flex min-w-5p"
                [gridApi]="gridApi"
                (cleared)="onFiltersCleared()"
            ></app-clear-filters>
        }
        @if (!!this.options.primaryGridAction) {
            <app-primary-grid-action
                [primaryGridAction]="this.options.primaryGridAction"
            ></app-primary-grid-action>
        }
        @if (this.options.exportCsv) {
            <app-export-csv
                class="flex min-w-5p"
                [gridApi]="gridApi"
                [options]="options.exportCsvOptions"
                [refreshDataForExport]="this.options.refreshDataForExport"
            ></app-export-csv>
        }
    </div>
}
